<template>
	<!-- 注册会员页面 -->
	<div class="fuzzy-matching-box">
		<div class="fuzzy-matching-top">
			<el-form @keyup.native.enter="inquiryClick">
				<el-row class="top-first-line">
					<el-col :span="4">
						<el-form-item label="账号:">
							<el-input v-model="Dform.memberName" placeholder=''></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="IMEI:">
							<el-input v-model="Dform.imei" placeholder=''></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="手机:">
							<el-input v-model="Dform.moblile" placeholder=''></el-input>
						</el-form-item>
					</el-col>

					<el-col :span="4">
						<!-- <el-form-item label="昵称:">
            <el-input v-model="Dform.name" placeholder=''></el-input>
          </el-form-item> -->
						<el-form-item label="所属用户:">
							<el-select ref="selectYi" v-model="belongArea" placeholder=""
								@visible-change='visibleChange("查询")'>
								<el-option :label="item.name" :value="item.id" v-for="item in belongAreaList"
									:key="item.name"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="3">
						<el-form-item label="微信">
							<!-- <el-input v-model="Dform.moblile" placeholder=''></el-input> -->
							<el-select v-model="bindWechat" filterable placeholder="是否绑定微信">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-button type="primary" class="query-button" @click="inquiryClick">查询</el-button>


				</el-row>

			</el-form>

			<div class="addStyle">
				<el-button type="text" class="textButton" @click="AddClick">新增家长</el-button>
				<el-button type="text" class="textButton" @click="daoRuClick">导入数据</el-button>
				<el-button type="text" class="textButton" @click="deriveFamily">导出数据报表</el-button>
				<el-button type="text" class="textButton" @click="downloadClick">下载模板</el-button>
			</div>
		</div>


		<div class="upload-box" v-if="shangchuanShow">
			<el-form-item label="所属用户：">
				<el-select ref="selectTo" v-model="theuserValue" placeholder="请选择数据来源"
					@visible-change='visibleChange("导入")' style="width: 200px;height: 35px;">
					<el-option :label="item.name" :value="item.id" v-for="item in leadingAreaList"
						:key="item.name"></el-option>
				</el-select>
			</el-form-item>
			<div class="upload-lef">
				<!-- <div @click="clickUpload">上传附件</div> -->
				<span class="upload-title">请选择要导入的数据文件：</span>
				<input class="upload" style="cursor: pointer;" id="inputFile" type="file" @change="getFile($event)" />
				<el-button type="primary" @click="uploadClick">上传</el-button>
			</div>
		</div>

		<!-- table表格 -->
		<div class="Table-Bottom">
			<el-table v-loading="loading" stripe :border="true"
				:header-cell-style="{ background: '#EDF6FF', color: '#000', height: '40px' }" ref="multipleTable"
				:data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column prop="memberName" label="账号" >
				</el-table-column>
				<!-- <el-table-column prop="code" label="关键字" show-overflow-tooltip>
        </el-table-column> -->
				<el-table-column prop="name" label="昵称" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="性别" show-overflow-tooltip min-width="50">
					<template #default="scope">
						<span v-if="scope.row.sex == 1">{{ '男' }}</span>
						<span v-if="scope.row.sex == 0">{{ '女' }}</span>
					</template>
				</el-table-column>
				<!-- <el-table-column prop="email" label="邮箱" show-overflow-tooltip>
        </el-table-column> -->
				<el-table-column prop="mobile" label="手机" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="绑定关系">
					<template #default="scope">
						<el-button 	v-if="scope.row.memberType == 1" type="primary" class="textButton" size="small" @click="addPeople(scope.row)"
							>
							<el-icon :size="20">
								<UserFilled />
							</el-icon>{{ scope.row.imeiListNumber }}人绑定
						</el-button>
						<el-button v-if="scope.row.memberType == 0" type="info" class="textButton" size="small" @click="addPeople(scope.row)">
							<el-icon :size="20">
								<UserFilled />
							</el-icon>家庭成员</el-button>
						<el-button v-if="scope.row.memberType == 2" type="info" class="textButton" size="small" @click="addPeople(scope.row)" >
						<el-icon :size="20" >
								<UserFilled />
						</el-icon>0人绑定</el-button>
					</template>
				</el-table-column>

				<el-table-column label="绑定微信">
					<template #default="scope">
						<img :src="scope.row.logo" alt="" style="height: 30px; width: 30px;"
							v-if="scope.row.logo != null && scope.row.logo != ''">
						<div type="text" size="small">{{ scope.row.nickName }}</div>
						<!-- <div type="text" size="small" style="color: #aaa; font-size: 16px;" v-if="scope.row.logo != null">{{  scope.row.createTime }}</div> -->
					</template>
				</el-table-column>

				<el-table-column label="微信推送" show-overflow-tooltip>
					<template #default="scope" style="background-color: green;">
						<el-avatar class="text-avatar" v-if="scope.row.openId != null" style="background: #79bbff; border-radius: 10px; margin: 15px; width: 55px; height: 40px;">是</el-avatar>
						<el-avatar class="text-avatar" style="background: #c8c9cc; border-radius: 10px; margin: 15px; width: 55px; height: 40px;" v-else >否</el-avatar>
					</template>
				</el-table-column>
				
				<el-table-column prop="imeiList" label="关联终端" show-overflow-tooltip min-width="100">
				</el-table-column>
				<el-table-column prop="recentlyActiveTime" label="最近登录时间" show-overflow-tooltip  min-width="100">
				</el-table-column>
				<!-- <el-table-column label="状态" show-overflow-tooltip>
					<template #default="scope">
						<span v-if="scope.row.status == 1">{{ '正常' }}</span>
						<span v-if="scope.row.status == 99">{{ '黑名单' }}</span>
					</template>
					</el-table-column> -->
				<el-table-column label="操作" min-width="100">
					<template #default="scope">
						<el-button class="textButton" type="text" size="small"
							@click="alterAdd(scope.row)">修改</el-button>
						<!-- <el-button class="textButton" type="text" size="small" @click="statusClick(scope.row)" v-if="scope.row.status == 1">加入黑名单</el-button> -->
						<el-button class="shanchuBtn" type="text" size="small" @click="tishiDelete(scope.row)"
							v-if="scope.row.imeiList != null">删除</el-button>
						<el-button class="shanchuBtn" type="text" size="small" @click="queryDelete(scope.row)"
							v-else>删除</el-button>
						<el-button class="textButton" type="text" size="small"
							@click="BindingAddShowClick(scope.row)">绑定终端</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="margin-top: 20px">
				<el-button @click="deleteClick">批量删除</el-button>
			</div>
			<div class="block">
				<!-- <span class="demonstration">直接前往</span> -->
				<div class="total"> 共<span class="texttiao">{{total}}</span>条记录，当前显示<span
						class="texttiao">{{ twigMin }}</span>到<span class="texttiao">{{ twigMax }}</span>条</div>

				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:page-size="pageInfo.pageSize" layout="prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<Add v-if="AddShow" :detailsObj="detailsObj" @AddShowClick="AddShowClick"></Add>
		<BindingAdd v-if="BindingAddShow" @BindingAddClick="BindingAddClick" :BindingAddObj="BindingAddObj">
		</BindingAdd>
		<People v-if="ShowPeople" @closeClick="closeClick" :vipObj="vipObj"></People>
		<userAreaDelete v-if="userAreaDelete" @handleClose='handleClose' @singleSelectionClick="singleSelectionClick">
		</userAreaDelete>

	</div>
</template>
<!--  -->
<script>
	import {
		memberList,
		memberDelete,
		memberUpdateStatus,
		memberDetailsInfo,
		memberImportMember,
		memberExportMember
	} from '@/assets/api/logapi'
	import {
		menuGetUserTree
	} from '@/assets/api/api'
	import People from './vipNewly/People.vue'
	import {
		ElMessage
	} from 'element-plus'
	import Add from './vipNewly/add.vue'
	import BindingAdd from './vipNewly/BindingAdd.vue'
	import {
		UserFilled
	} from "@element-plus/icons-vue"; // 图标
	import userAreaDelete from '@/components/userArea/index.vue';

	export default {
		components: {
			Add,
			BindingAdd,
			UserFilled,
			People,
			userAreaDelete,
		},
		data() {
			return {
				BindingAddShow: false,
				AddShow: false,
				loading: true,
				ShowPeople: false,
				detailsObj: {},
				Dform: {
					imei: '',
					memberName: '',
					moblile: '',
					name: ''
				},

				pageInfo: {
					page: 1,
					pageSize: 8,
				},
				multipleSelection: [],
				tableData: [],
				total: '',
				shangchuanShow: false,
				theuserValue: '',
				theuserList: [],
				tempFile: "", //文件
				BindingAddObj: {},
				vipObj: {},
				userAreaDelete: false,
				belongAreaList: [],
				belongArea: '',
				leadingAreaList: [],
				userAreaName: '',
				options: [{
					value: 0,
					label: '否'
				}, {
					value: 1,
					label: '是'
				}],
				bindWechat: '',
				twigMax: 0,
				twigMin: 0,
			}
		},
		created() {
			this.memberListSearch()
			// this.menuGetUserTreeGet()
		},
		methods: {
			visibleChange(value) {
				this.userAreaName = value
				this.userAreaDelete = true
				if (value == '导入') {
					this.$refs.selectTo.blur()
				} else if (value == '查询') {
					this.$refs.selectYi.blur()
				}
			},
			singleSelectionClick(item) {
				if (this.userAreaName == '查询') {
					this.belongAreaList = [item]
					this.belongArea = item.id
					this.inquiryClick()
				} else if (this.userAreaName == '导入') {
					this.leadingAreaList = [item]
					this.theuserValue = item.id
				}
				this.userAreaDelete = false
				console.log(item, item.name, '单选');
			},
			handleClose() {
				this.userAreaDelete = false
			},
			//查看人员绑定关系
			addPeople(item) {
				// console.log(item, '查看');
				this.vipObj = item
				this.ShowPeople = true

			},
			closeClick() {
				this.ShowPeople = false

			},
			//下载模板
			downloadClick() {
				window.location.href = 'https://peizhe-1315512235.cos.ap-guangzhou.myqcloud.com/gts/members.xls'
			},
			BindingAddShowClick(item) {
				this.BindingAddShow = true
				this.BindingAddObj = item
			},
			BindingAddClick() {
				this.BindingAddShow = false
				this.memberListSearch()
			},
			deriveFamily(val) {
				let params = {
					imei: this.Dform.imei,
					memberName: this.Dform.memberName,
					mobile: this.Dform.moblile,
					bindWechat: this.bindWechat,

					page: 1,
					pageSize: 9999,
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				memberExportMember(params).then((res) => {
					this.handleExport(res.data, '数据报表.xls')
				}).catch((err) => {
					ElMessage.error("导出数据报表失败")
				})
			},
			daoRuClick() {
				this.shangchuanShow = true
			},
			getFile(event) {
				this.tempFile = event.target.files[0];
			},
			uploadClick() {
				let index = this.tempFile.name.lastIndexOf(".");
				let fileName = this.tempFile.name.substr(index + 1);
				var filetypes = [
					"jpg",
					"png",
					"gif",
					"jpeg",
					"doc",
					"ppt",
					"xls",
					"pdf",
					"docx",
					"xlsx",
				];
				if (filetypes.includes(fileName)) {
					if (this.tempFile) {
						let fileSize = this.tempFile.size / (1024 * 1024 * 60);
						if (fileSize > 1) {
							this.$message.error({
								message: "文件不能超过60M！"
							});
						} else {
							if (this.tempFile.name) {
								let formData = new FormData();
								console.log(formData, 8888888);
								formData.append("file", this.tempFile);
								console.log(this.tempFile, formData.getAll('file'));

								memberImportMember(formData, this.theuserValue).then((res) => {
									console.log(res);
									ElMessage({
										message: '会员导入数据报表上传成功',
										type: 'success',
									})
									this.shangchuanShow = false
								}).catch((err) => {
									ElMessage.error("上传失败")
								})
							}
						}
					}
				} else {
					ElMessage.error("请上传jpg,png,gif,jpeg,doc,ppt,xls,pdf,docx,xlsx格式的文件!")
				}

			},
			AddClick() {
				this.AddShow = true
			},
			AddShowClick() {
				this.AddShow = false
				this.detailsObj = {}
				this.memberListSearch()
			},
			alterAdd(item) {
			
				memberDetailsInfo(item.memberId).then((res) => {
					this.detailsObj = res.data.data
					this.AddShow = true
				}).catch((err) => {
					console.log(err, 'shibai');

				})



			},
			memberListSearch() {
				let Id = null
				if (this.belongAreaList.length && this.belongArea != '') {
					Id = this.belongArea
				} else {
					Id = JSON.parse(localStorage.getItem('user')).id
				}
				const params = {
					imei: this.Dform.imei,
					memberName: this.Dform.memberName,
					mobile: this.Dform.moblile,
					bindWechat: this.bindWechat,
					userId: Id,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					// userId: JSON.parse(localStorage.getItem('user')).id,
				}
				memberList(params).then((res) => {
					console.log(res, '会员liebiao');
					this.tableData = res.data.data.list
					for (let item of this.tableData) {
						if (item.imeiList != null) {
							let str = item.imeiList.split(",");
							item.imeiListNumber = str.length
						}
					}
					this.total = res.data.data.total
					this.loading = false
					console.log(this.tableData, '会员liebiao');

					let str = 0
					if (res.data.data.list.length < 8) {
						str = 8 - res.data.data.list.length
					}
					console.log(this.pageInfo.pageSize * this.pageInfo.page - 7, ']]]]]', this.pageInfo.pageSize *
						this.pageInfo.page - str);
					this.twigMin = this.pageInfo.pageSize * this.pageInfo.page - 7
					this.twigMax = this.pageInfo.pageSize * this.pageInfo.page - str

					console.log(this.tableData, 789789, this.total, res.data.total);
				}).catch((err) => {
					console.log(err, '会员liebiao');

				})
			},

			inquiryClick() {
				this.pageInfo.page = 1
				this.memberListSearch()
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log(this.multipleSelection, val, 'this.multipleSelection');
			},
			statusClick(item) {
				// console.log(item,'huiyuanzhuangtai ');  
				let params = {
					memberId: item.memberId,
					status: item.status
				}
				memberUpdateStatus(params).then((res) => {
					// console.log(res,'会员状态修改');
					this.memberListSearch()
				}).catch((err) => {
					// console.log(err,'会员状态失败');
				})

			},

			deleteClick() {
				if (!this.multipleSelection.length) {
					ElMessage.error('请先选中需要删除的终端。')
				} else {
					let arr = []
					for (let value of this.multipleSelection) {
						console.log(value.memberId, 5555555);
						arr.push(value.memberId)
					}
					let params = {
						userId: JSON.parse(localStorage.getItem('user')).id,
						ids: arr
					}
					memberDelete(params).then((res) => {
						console.log(res, '删除接口');
						// this.searchClick()
						ElMessage({
							message: '删除成功',
							type: 'success',
						})
						this.multipleSelection = []
						this.memberListSearch()
					}).catch((err) => {
						console.log(err);
					})
				}
			},
			singleDeleteClick(item) {
				console.log(item, 7777);
				let params = {
					ids: [item.memberId],
					loginUserId: JSON.parse(localStorage.getItem('user')).id,

				}
				memberDelete(params).then((res) => {
					this.memberListSearch()
				}).catch((err) => {
					console.log(err);
				})
			},
			//已绑定设备删除提示
			tishiDelete(item) {
				if (item.imeiList) {
					this.$message({
						type: 'error',
						message: '请先解绑终端，再删除!'
					});
				} else {
					this.$confirm('已经绑定设备，请确认是否删除注册会员？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.singleDeleteClick(item)
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					}).catch((err) => {
						console.log(err, '关机');
						this.$message({
							type: 'error',
							message: err.response.data.msg
						});
					});
				}



			},
			// 确定删除提示
			queryDelete(item) {
				this.$confirm('确定删除此注册会员？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.singleDeleteClick(item)
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch((err) => {
					console.log(err, '关机');
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				});

			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.memberListSearch()
			},
			menuGetUserTreeGet() {
				let params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				menuGetUserTree(params).then((res) => {
					console.log(res, res.data.data[0], '获取--所属用户下拉框');
					this.theuserList = [...res.data.data, ...res.data.data[0].children]
					for (let item of this.theuserList) {
						item.label = item.username
						item.value = item.id
					}
				}).catch((err) => {
					console.log(err);
				})
			},
			handleExport(data, name) {
				// 动态创建iframe下载文件
				let fileName = name;
				if (!data) {
					return;
				}
				let blob = new Blob([data], {
					type: "application/octet-stream"
				});
				console.log(blob);
				if ("download" in document.createElement("a")) {
					// 不是IE浏览器
					let url = window.URL.createObjectURL(blob);
					let link = document.createElement("a");
					link.style.display = "none";
					link.href = url;
					link.setAttribute("download", fileName);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link); // 下载完成移除元素
					window.URL.revokeObjectURL(url); // 释放掉blob对象
				} else {
					// IE 10+
					window.navigator.msSaveBlob(blob, fileName);
				}
			},
		}
	}
</script>

<!-- porimse -->
<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 40px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 95%;
		background-color: #fff;
		border-radius: 8px;

		.title-top {
			// padding: 20px 20px;
		}

		.textButton {
			// background-color: pink;
			margin: 2px;
			padding: 0px;
			font-size: 15px;
			font-weight: 700;

		}
		
		.text-avatar {
			// background-color: pink;
			margin: 2px;
			padding: 0px;
			font-size: 15px;
			font-weight: 700;
		}

		.fuzzy-matching-top {
			// height: 120px ;
			background-color: #fff;
			border-radius: 8px;

			.top-first-line {
				/deep/ {
					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
						font-weight: 700;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}

					.el-button--small {
						width: 50px;
						height: 30px;
						margin-left: 20px;
						margin-top: 3px;
					}

					.el-select--small .el-select__wrapper {
						height: 35px !important;
					}
				}

				.addStyle {}

			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				.query-button {
					position: absolute;
					right: 800px;
					// padding: 16px 24px;
					width: 40px;
					height: 40px !important;
					// top: 50%;
					// transform: translate(0,-50%);
				}
			}

			/deep/ {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}

			}

			.el-button--text {
				margin-left: 50px;
				margin-top: 10px;
				font-size: 16px;
			}
		}

		.block {
			display: flex;
			justify-content: center;
			text-align: center;
			font-size: 15px;

			.sorter {
				margin-left: 50px;
			}

			.total {
				padding-top: 5px;
				margin-left: 800px;

			}

			.texttiao {
				color: #459FFC;

			}
		}

		.Table-Bottom {
			height: calc(100% - 50px);
			overflow: auto;
			// position: relative;
			padding: 0px 20px;
			padding-top: 20px;
			// margin-top: 15px;
			border-radius: 8px;

			/deep/ {
				.el-table .cell {
					// font-size: 15px;
					font-size: 16px;
					color: black;
					// font-weight: 700;
					text-align: center;
				}

				.el-table th.el-table__cell>.cell {
					font-weight: 700;
				}
			}

			.textButton {
				// background-color: pink;
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;

			}

			.shanchuBtn {
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
				color: red;
			}
		}

		.upload-box {
			margin-top: 15px;

			.upload-lef {
				margin-left: 20px;
				font-size: 14px;

				.upload-title {}
			}

			.el-table tr {
				font-size: 20px;
			}

			/deep/ {


				.el-select .el-input__inner {
					height: 35px;
				}

				.el-form-item--small .el-form-item__label {
					margin-left: 20px;
					line-height: 35px;
				}


				.el-upload-list {
					// dis
					// font-size: 80px;
				}


			}
		}
	}
</style>